module.exports = __webpack_public_path__ + "Frame388-9456ebe1.webp";